import { Component } from '@angular/core';

@Component({
    selector: 'wkk-health',
    template: "{{'{'}}\"status\":\"ok\"{{'}'}}",
    standalone: false
})
export class HealthComponent {}
